
const { moment } = require("../../util/date");
const cookies = require('js-cookie');

function controller($http, $timeout, $interval, $q) {
    const vm = this;

    vm.active_resources = [];
    vm.expired_resources = [];
    vm.has_clipboard = !!navigator.clipboard;
    vm.logged_in = !!cookies.get('_bo_logged_in');

    vm.init = () => {
        if (!vm.logged_in) {
            // Bypass below checks as they'll just fail anyway
            return;
        }

        const sharedResources = $http.get(`${window.AppConfig.boURL}/edu/shared-resources`, {withCredentials: true});
        const resourceData = $http.get('/edu/feeds/resources');


        $q.all([sharedResources, resourceData]).then(responses => {
            const resourceCMSData = responses[1].data;

            const resources = responses[0].data.map(resource => {
                const cmsData = resourceCMSData.find(data => parseInt(data.id, 10) === parseInt(resource.resourceId, 10));

                if (cmsData) {
                    resource.title = cmsData.title;
                    resource.page_url = cmsData.url;
                }

                resource.expiry = moment(resource.expirationDate.date);
                return resource;
            });
                const now = moment();

                [vm.active_resources, vm.expired_resources] = resources.reduce((carry, resource) => {
                    const idx = parseInt(resource.expiry.format('X')) > parseInt(now.format('X')) ? 0 : 1;
                    carry[idx].push(resource);
                    return carry;
                }, [[], []]);

                vm.active_resources.forEach(resource => {
                    resource.share_copied = false;
                    resource.expiry_time = false;
                    const expiry_time = moment(resource.expirationDate.date);

                    const intervalPromise = $interval(() => {
                        // Updates expiry time
                        const now = moment();
                        resource.expiry_time = expiry_time.from(now, true);

                        if (expiry_time.isBefore(now)) {
                            resource.expiry_time = 'Expired';
                            $interval.cancel(intervalPromise);

                            vm.active_resources = vm.active_resources.filter(item => item.url !== resource.url);
                            vm.expired_resources.push(resource);
                        }
                    }, 250);
                });
            });
    };

    vm.copyUrl = resource => {
        navigator.clipboard.writeText(resource.url)
            .then(() => {
                $timeout(() => {
                    resource.share_copied = true;
                }, 0);
            });
    }
}

module.exports = [
    '$http', '$timeout', '$interval', '$q', controller
];
